import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const siteSettingApi = createApi({
  reducerPath: "siteSettingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "setting_site",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getSiteSettingApi: builder.query({
      query: () => ({
        url: "",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetSiteSettingApiQuery} = siteSettingApi ;